<template>
  <div class="mx-auto bg-beige1 md:flex md:justify-center md:gap-x-4 md:px-4">
    <div class="flex max-w-[700px] flex-col gap-y-4 font-Spectral md:py-8">
      <div class="bg-white py-8 md:hidden">
        <ReservationWizard class="mb-4" :current-reservation-step-label="currentStep" :reservation-type="reservationType" />
      </div>
      <AttentionSection :email="email" :reservation-type="reservationType" />
      <!-- SPのみ表示：体験タイトルと画像表示 + 予約情報表示セクション -->
      <SummarySection
        class="bg-white px-4 py-8 md:hidden"
        :experience-event="experienceEvent"
        :is-done-reservation="true"
        :on-click-image="onClickBackToExperienceDetail"
        :pre-reservation-price="preReservationPrice"
        :pre-reservation-price-with-guest-type="preReservationPriceWithGuestType"
        :reservation-step1-form="reservationStep1Form"
        :reservation-step2-form="reservationStep2Form"
        :slug="slug"
      />
      <!--
        完了ページの補足セクション差し込み口（予約後質問の回答フォーム等）。
        Request In Review / Booking Confirmed と Cancellation Policy の間に置く。
        ページ末尾だと予約情報・レコメンドに埋もれて気付かれないため。
      -->
      <slot name="before-cancel-policy" />
      <div class="flex flex-col gap-y-4 bg-white px-4 py-8 md:px-10">
        <CancelPolicySection
          :cancellation-policy-trigger="experienceEvent.cancellationPolicyTrigger"
          :is-ladder-enabled="experienceEvent.experience.isLadderEnabled"
          :refundable-cancellation-days-for-guest="experienceEvent.experience.refundableCancellationDaysForGuest"
        />
        <AtomsPrimaryButton class="w-full max-w-[270px] md:max-w-[370px]" data-testid="submit" :on-click="onClickBackToHome">HOME</AtomsPrimaryButton>
      </div>
    </div>
    <!-- PCのみ表示：体験タイトルと画像表示 + 予約情報表示セクション -->
    <!-- 右側の固定 -->
    <div class="mt-8 hidden h-max w-1/3 min-w-[280px] max-w-[360px] bg-white px-4 py-8 md:block">
      <ReservationWizard class="mb-4" :current-reservation-step-label="currentStep" :reservation-type="reservationType" />
      <SummarySection
        :experience-event="experienceEvent"
        :is-done-reservation="true"
        :on-click-image="onClickBackToExperienceDetail"
        :pre-reservation-price="preReservationPrice"
        :pre-reservation-price-with-guest-type="preReservationPriceWithGuestType"
        :reservation-step1-form="reservationStep1Form"
        :reservation-step2-form="reservationStep2Form"
        :slug="slug"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { WabunkaExperienceEventReservationType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event_reservation_type';

import type {
  ExperiencePreReservationPriceViewModel,
  ExperiencePreReservationPriceWithGuestTypeViewModel,
  WabunkaReservationFormStep1,
  WabunkaReservationFormStep2,
} from '@/wabunka-src/features/Experience';
import { ReservationWizard, SummarySection, CancelPolicySection, AttentionSection } from '@/wabunka-src/features/Experience';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

const props = defineProps<{
  slug: string;
  email: string;
  experienceEvent: WabunkaExperienceEventViewModel;
  reservationStep1Form: WabunkaReservationFormStep1;
  reservationStep2Form: WabunkaReservationFormStep2;
  preReservationPrice: ExperiencePreReservationPriceViewModel;
  preReservationPriceWithGuestType?: ExperiencePreReservationPriceWithGuestTypeViewModel;
  reservationType?: WabunkaExperienceEventReservationType;
  onClickBackToHome: () => void;
  onClickBackToExperienceDetail: () => void;
}>();

const currentStep = computed(() => {
  return props.reservationType === WabunkaExperienceEventReservationType.EXPERIENCE_EVENT_RESERVATION_TYPE_INSTANT ? 'Confirmed' : 'Requested';
});
</script>
